var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.46 63.43C49.9564 63.43 64.14 49.2464 64.14 31.75C64.14 14.2536 49.9564 0.0700073 32.46 0.0700073C14.9636 0.0700073 0.780029 14.2536 0.780029 31.75C0.780029 49.2464 14.9636 63.43 32.46 63.43Z",
    fill: "#E0A648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.4599 59.77C47.935 59.77 60.4799 47.225 60.4799 31.75C60.4799 16.275 47.935 3.72998 32.4599 3.72998C16.9849 3.72998 4.43994 16.275 4.43994 31.75C4.43994 47.225 16.9849 59.77 32.4599 59.77Z",
    fill: "#FFF3E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5702 54.05C43.5702 54.05 41.8302 53.72 39.8502 51.57C37.2002 48.7 33.3002 37.28 35.4902 35.41C37.6402 33.58 47.1902 38.78 49.7602 41.66C51.7702 43.91 52.2402 46.62 52.2402 46.62C52.2402 46.62 50.9802 50.63 49.6002 51.91C48.2302 53.18 43.5702 54.05 43.5702 54.05Z",
    fill: "#E0A648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.27 54.05C21.27 54.05 20.88 51.99 21.27 49.09C21.79 45.22 28.43 35.95 31.26 36.45C34.04 36.94 36.71 49 36.14 52.81C35.69 55.79 34.9 56.53 34.9 56.53C34.9 56.53 29.33 58.02 27.47 57.77C25.61 57.52 21.27 54.05 21.27 54.05Z",
    fill: "#E0A648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64014 37.94C7.64014 37.94 8.75014 35.54 11.3601 34.22C14.8401 32.46 26.5601 31.19 27.7601 33.81C28.9301 36.38 21.0301 44.93 17.5601 46.61C14.8501 47.93 12.6001 46.61 12.6001 46.61C12.6001 46.61 9.73014 44.57 8.88014 42.89C8.03014 41.21 7.64014 37.94 7.64014 37.94Z",
    fill: "#E0A648"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6001 16.88C12.6001 16.88 14.8301 17.09 17.5601 18.12C21.2101 19.5 28.7101 26.81 27.5901 29.46C26.4901 32.06 14.9501 31.93 11.3701 30.51C8.57007 29.4 7.65007 26.79 7.65007 26.79C7.65007 26.79 6.93007 22.8 7.59007 21.05C8.24007 19.29 12.6001 16.88 12.6001 16.88Z",
    fill: "#E0A648"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.42 6.97C32.42 6.97 34.1 9.12 34.9 11.93C35.97 15.68 33.94 25.83 31.15 26.51C28.4 27.18 22.27 19.37 21.27 15.65C20.49 12.74 21.27 9.46 21.27 9.46C21.27 9.46 24.42 6.26 26.23 5.74C28.03 5.21 32.42 6.97 32.42 6.97Z",
    fill: "#E0A648"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2501 15.64C52.2501 15.64 52.7501 18.25 51.0101 20.6C48.6801 23.73 37.7201 29.3 35.4801 27.49C33.2801 25.71 37.5001 14.98 39.8601 11.92C41.7001 9.53 42.3401 9.44 42.3401 9.44C42.3401 9.44 47.5801 9.46 49.0901 10.57C50.5901 11.7 52.2501 15.64 52.2501 15.64Z",
    fill: "#E0A648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 36.71C57.2 36.71 55.16 37.76 52.24 37.95C48.35 38.2 37.44 34.43 37.37 31.55C37.3 28.72 48.39 24.51 52.24 24.32C55.25 24.18 57.2 25.56 57.2 25.56C57.2 25.56 58.94 29.08 59.07 30.96C59.19 32.82 57.2 36.71 57.2 36.71Z",
    fill: "#E0A648"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.9301 33.01C29.4801 31.83 28.6401 30.63 29.2901 29.65C29.7201 29 30.4201 29.5 31.2001 29.21C32.2401 28.82 33.2601 27.89 34.1801 28.35C35.0001 28.76 35.6801 29.48 36.0301 30.4C36.4901 31.62 35.7101 32.01 35.0101 33.01C34.5901 33.61 34.5601 35.02 33.8201 35.3C33.1401 35.56 32.4201 35.61 31.7501 35.47C30.4901 35.24 30.4101 34.29 29.9301 33.01Z",
    fill: "#FFF3E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M48.0601 32.13C47.7701 32.13 38.0901 31.98 38.0901 31.76C38.0901 31.54 47.7701 31.35 48.0601 31.35C48.3501 31.35 48.5801 31.52 48.5801 31.74C48.5801 31.96 48.3501 32.13 48.0601 32.13Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.33 44.14C42.15 43.92 36.17 36.3 36.34 36.16C36.51 36.02 42.75 43.42 42.93 43.65C43.11 43.87 43.12 44.17 42.96 44.3C42.8 44.43 42.52 44.37 42.33 44.14Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2401 19.25C43.0501 19.47 36.5901 26.68 36.4301 26.54C36.2701 26.4 42.4601 18.96 42.6501 18.74C42.8401 18.52 43.1201 18.46 43.2901 18.6C43.4501 18.74 43.4301 19.03 43.2401 19.25Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.09 25.16C17.36 25.26 26.42 28.68 26.35 28.88C26.28 29.08 17.1 25.99 16.83 25.9C16.56 25.8 16.4 25.56 16.47 25.36C16.54 25.15 16.82 25.06 17.09 25.16Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.16 38.27C17.42 38.14 26.2 34.06 26.29 34.25C26.38 34.44 17.76 38.84 17.5 38.97C17.24 39.1 16.95 39.04 16.86 38.85C16.77 38.66 16.9 38.4 17.16 38.27Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.6001 47.37C28.6501 47.09 30.6201 37.61 30.8301 37.65C31.0401 37.69 29.4201 47.23 29.3601 47.52C29.3101 47.8 29.0901 48 28.8801 47.96C28.6701 47.92 28.5401 47.65 28.6001 47.37Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.0501 15.08C29.1101 15.36 30.9301 24.87 30.7201 24.92C30.5101 24.97 28.3501 15.53 28.2901 15.24C28.2301 14.96 28.3501 14.69 28.5601 14.65C28.7701 14.6 28.9901 14.8 29.0501 15.08Z",
    fill: "#FFF3E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.8416b837ee1f25decc8a07317a25bf9e.svg";
export { ForwardRef as ReactComponent };